import { create } from 'zustand';


export const useBusinessInfo = create<{
  businessInfo: any;
  aiSearchStatus: string; // init 初始化，loading 加载中，success 成功，error 错误
  setBusinessInfo: (v: any) => void;
  setAiSearchStatus: (v: string) => void;
}>((set) => ({
  businessInfo: {},
  aiSearchStatus: 'init',
  setBusinessInfo: (v: any) => {
    set((state) => ({ ...state, businessInfo: { ...state.businessInfo, ...v } }));
  },
  setAiSearchStatus: (v: string) => {
    set((state) => ({ ...state, aiSearchStatus: v }));
  },
}));